module.exports = __webpack_public_path__ + "static/media/mq.b1bba6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mq.png
// module id = 1928
// module chunks = 0